<!--
 * @Description: 代发商品页面组件
 -->
<template>
  <div class="daifa-page">
    <!-- 顶部容器 -->
    <div class="page-container">
      <!-- 分类标签 -->
      <!-- <div class="category-section">
        <div class="category-tabs">
          <div class="tab-item" :class="{ active: query.area_id === '0' }" @click="changeMarket('0')">
            <span class="tab-icon"><i class="el-icon-shopping-bag-1"></i></span>
            <span class="tab-text">全部</span>
          </div>
          <div class="tab-item" :class="{ active: query.area_id === '1' }" @click="changeMarket('1')">
            <span class="tab-icon"><i class="el-icon-office-building"></i></span>
            <span class="tab-text">五亭龙</span>
          </div>
        </div>
      </div> -->

      <!-- 面包屑和统计 -->
      <div class="breadcrumb-section">
        <div class="breadcrumb">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item to="/">首页</el-breadcrumb-item>
            <el-breadcrumb-item>代发商品</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
        <div class="total-count">
          <span class="count-num">{{ total }}</span>
          <span class="count-text">件商品</span>
        </div>
      </div>

      <!-- 筛选工具栏 -->
      <div class="filter-section">
        <div class="filter-tags">
          <div class="filter-tag" :class="{ active: query.sort === '' }" @click="changeSort('')">
            综合
          </div>
          <div class="filter-tag" :class="{ active: query.sort === 'PHotNum' }" @click="changeSort('PHotNum')">
            <span>浏览量</span>
            <i class="el-icon-sort-down"></i>
          </div>
          <div class="filter-tag" :class="{ active: query.sort === 'PBuyNum' }" @click="changeSort('PBuyNum')">
            <span>下载量</span>
            <i class="el-icon-sort-down"></i>
          </div>
          <div class="filter-tag" :class="{ active: query.sort === 'ITime' }" @click="changeSort('ITime')">
            <span>上新时间</span>
            <i class="el-icon-sort-down"></i>
          </div>
          <div class="date-picker-wrap">
            <el-date-picker v-model="query.dateRange" type="daterange" range-separator="至" start-placeholder="开始日期"
              end-placeholder="结束日期" value-format="yyyy-MM-dd" @change="changeDate" size="medium" />
          </div>
        </div>
        <div>
          <el-pagination background layout="prev, pager, next" :page-size="query.pageSize"
            :current-page="query.page" :total="total" @current-change="currentChange" />
        </div>
      </div>

      <!-- 商品列表 -->
      <div class="products-section" v-loading="loading" element-loading-text="加载中...">
        <GoodsList :list="list" v-if="list.length > 0"></GoodsList>
        <div v-else class="empty-state">
          <img src="@/assets/imgs/cart-empty.png" alt="暂无商品" />
          <p>暂无商品，请换个条件试试</p>
        </div>
      </div>

      <!-- 分页 -->
      <div class="pagination-section">
        <el-pagination background layout="total, prev, pager, next" :page-size="query.pageSize"
          :current-page="query.page" :total="total" @current-change="currentChange" />
      </div>
    </div>
  </div>
</template>
<script>
import GoodsList from "./../components/GoodsList";

export default {
  name: "Daifa",
  components: {
    GoodsList,
  },
  data() {
    return {
      loading: true,
      list: [], // 商品列表
      total: 50, // 商品总量
      currentPage: 1, //当前页码
      search: "", // 搜索条件
      query: {
        area_id: '1',
        skuFlag: 1,
        dateRange: [],
        sort: '',
        page: 1,
        pageSize: 25,
      },
    };
  },
  created() {
    this.getData();
  },
  methods: {
    /**
     * 切换市场
     * @param {*} index
     */
    changeMarket(index) {
      this.loading = true;
      this.query.area_id = index;
      this.query.page = 1;
      this.getData();
    },
    /**
     * 切换排序
     * @param {*} sort
     */
    changeSort(sort) {
      this.loading = true;
      this.query.sort = sort;
      this.query.page = 1;
      this.getData();
    },
    /**
     * 变更时间
     * @param {*} dateRange
     */
    changeDate(dateRange) {
      this.loading = true;
      if (dateRange === null) {
        this.query.start = "";
        this.query.end = "";
      } else {
        const [start, end] = dateRange;
        this.query.start = start;
        this.query.end = end;
      }
      this.query.page = 1;
      this.getData();
    },
    /**
     * 变更页码
     * @param {*} currentPage
     */
    currentChange(currentPage) {
      this.loading = true;
      this.query.page = currentPage;
      this.getData();
    },
    /**
     * 获取列表数据
     */
    async getData() {
      const queryString = new URLSearchParams(
        Object.entries(this.query)
      ).toString();
      const { data } = await this.$axios.get(
        this.$newApi + "/api/rbh/goods/list?" + queryString
      );
      this.list = data.data.list;
      this.total = data.data.totalCount;
      this.loading = false;
    },
  },
};
</script>

<style scoped>
/* 页面整体 */
.daifa-page {
  min-height: 100vh;
  background: linear-gradient(180deg, #f5f7fa 0%, #fff 100%);
  padding: 20px 0 40px;
}

.page-container {
  width: 1240px;
  margin: 0 auto;
}

/* 分类标签区域 */
.category-section {
  background: white;
  border-radius: 12px;
  padding: 20px;
  margin-bottom: 20px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);
}

.category-tabs {
  display: flex;
  gap: 15px;
}

.tab-item {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 16px;
  background: #f8f9fa;
  border-radius: 15px;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 13px;
}

.tab-item:hover {
  background: #fff5f5;
  transform: translateY(-1px);
}

.tab-item.active {
  background: linear-gradient(135deg, #ff6b6b 0%, #ee5a5a 100%);
  color: white;
  box-shadow: 0 2px 8px rgba(255, 107, 107, 0.3);
}

.tab-icon {
  font-size: 14px;
}

.tab-text {
  font-size: 13px;
  font-weight: 500;
}

/* 面包屑区域 */
.breadcrumb-section {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
  padding: 10px 15px;
  background: white;
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);
}

.breadcrumb .el-breadcrumb {
  line-height: 1;
}

.breadcrumb-section .el-breadcrumb__item {
  font-size: 13px;
}

.total-count {
  display: flex;
  align-items: baseline;
  gap: 5px;
}

.count-num {
  font-size: 20px;
  font-weight: 700;
  color: #ff6b6b;
}

.count-text {
  font-size: 13px;
  color: #999;
}

/* 筛选区域 */
.filter-section {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 15px;
  background: white;
  border-radius: 12px;
  margin-bottom: 10px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);
}

.filter-tags {
  display: flex;
  gap: 8px;
}

.filter-tag {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 6px 12px;
  background: #f8f9fa;
  border-radius: 15px;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 13px;
  color: #666;
}

.filter-tag:hover {
  background: #fff5f5;
  color: #ff6b6b;
}

.filter-tag.active {
  background: linear-gradient(135deg, #ff6b6b 0%, #ee5a5a 100%);
  color: white;
}

.date-picker-wrap .el-date-editor {
  border-radius: 25px;
}

/* 商品列表区域 */
.products-section {
  min-height: 500px;
  background: white;
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);
}

.empty-state {
  text-align: center;
  padding: 80px 0;
}

.empty-state img {
  width: 200px;
  height: 200px;
  opacity: 0.6;
  margin-bottom: 20px;
}

.empty-state p {
  font-size: 16px;
  color: #999;
}

/* 分页区域 */
.pagination-section {
  display: flex;
  justify-content: center;
  margin-top: 30px;
}

.pagination-section .el-pagination {
  padding: 10px 20px;
  background: white;
  border-radius: 25px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);
}

.pagination-section .el-pagination.is-background .el-pager li {
  border-radius: 50%;
  margin: 0 3px;
}

.pagination-section .el-pagination.is-background .el-pager li.active {
  background: linear-gradient(135deg, #ff6b6b 0%, #ee5a5a 100%);
}

/* Element UI 覆盖样式 */
.el-breadcrumb__inner {
  color: #666 !important;
}

.el-breadcrumb__inner.is-link:hover {
  color: #ff6b6b !important;
}

.el-date-editor .el-input__inner {
  border-radius: 20px;
}
</style>
